import { createAsyncThunk } from "@reduxjs/toolkit";
import { postGuestMessageApi, postGuestImageApi, loadChatsApi } from "./api";

export const postGuestMessage = createAsyncThunk("postGuestMessage", async (payload) => {
	const res = await postGuestMessageApi(payload);
	return res.data;
});

export const postGuestImage = createAsyncThunk("postGuestImage", async (payload) => {
	try {
		const res = await postGuestImageApi(payload);
		return res.data;
	} catch (err) {
		console.log(err);

		throw err;
	}
});

export const loadChatsAction = createAsyncThunk("loadGuestChats", async (payload) => {
	const res = await loadChatsApi(payload);
	return res.data;
});
